import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useAddDisplayWebContent = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, segmentId: string) => {
      dispatch({
        type: 'ADD_DISPLAY_WEB_CONTENT',
        payload: {
          id,
          segmentId,
        },
      });
    },
    [dispatch],
  );
};
